"use client";

import { usePathname } from "next/navigation";
const SpacerForDetailPage = () => {
  const pathname = usePathname();
  if (!pathname || !pathname?.startsWith("/detail")) {
    return null;
  }
  return <div className='h-[210px] md:h-[224px] lg:h-0' data-sentry-component="SpacerForDetailPage" data-sentry-source-file="SpacerForDetailPage.tsx"></div>;
};
export default SpacerForDetailPage;